import { Injectable, Injector } from "@angular/core";
import { EntityCollectionServiceElementsFactory } from "@ngrx/data";
import { AbstractRepositoryV2 } from "src/app/modules/core/service/v2/abstractRepositoryV2";
import { MedicalDeviceModel } from "../../../api/entity/medicalDevice.model";

@Injectable({
    providedIn: 'root'
})
export class MedicalDeviceRepository extends AbstractRepositoryV2<MedicalDeviceModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('MedicalDevice', serviceElementsFactory, injector);
    }
}

